/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type HorizontalStructureEnum = 1 | 2 | 3 | 4 | 5;

export const HorizontalStructureEnum = {
    NUMBER_1: 1 as HorizontalStructureEnum,
    NUMBER_2: 2 as HorizontalStructureEnum,
    NUMBER_3: 3 as HorizontalStructureEnum,
    NUMBER_4: 4 as HorizontalStructureEnum,
    NUMBER_5: 5 as HorizontalStructureEnum
};

